<template>
  <div class="scenens" data-type="scenes">
    <div v-show="!S_GlobalSearch" style="padding-bottom: 50px">
      <!-- <div class="collect-scene">
        <span  class="add-icon" @click="collectScenes()" style="cursor: pinter;position: relative; top: -2px; margin-top: -8px;">
          <span style="position: relative; top: -1px; left: 0px; color: #fff; font-weight: blod;">
            +
          </span>
        </span>
        <span style="margin-top: -8px;">收藏当前场景</span>
      </div>-->

      <!-- 横竖 -->
      <div v-show="false" class="optimized">
        <div
          :class="{
            horizontal: true,
            hover: optimized == 1 ? false : true,
            active: optimized == 1,
          }"
          @click="
            optimized = 1;
            materialPushAnalysis({ type: 'sceneLandscape' });
          "
        >
          横版
        </div>
        <div
          :class="{
            Vertical: true,
            hover: optimized == 2 ? false : true,
            active: optimized == 2,
          }"
          @click="
            optimized = 2;
            materialPushAnalysis({ type: 'scenePortrait' });
          "
        >
          竖版
        </div>
      </div>

      <div
        class="data-body"
        v-for="(item, index) in category"
        :key="item.id"
        :class="{ operation: (dataArray['_' + item.id] || {}).judge }"
        :style="{
          height: (dataArray['_' + item.id] || {}).judge ? 'auto' : '146px',
        }"
      >
        <sectionCategory
          :itemData="item"
          :itemIndex="index"
          :boxName="boxName"
          @scrollTop="scrollTop"
          @getData="getData"
          @dataBoxAction="dataBoxAction"
        />

        <div
          class="body-list"
          :style="{
            height: ((dataArray['_' + item.id] || {}).data || {}).length
              ? dataArray['_' + item.id].WFSheight + 30 + 'px'
              : '150px',
            // --每个slide文件都会有注释这个css属性，禁止分组图固定在素材栏上方--
            // 'margin-top': fixTopId.id === ('_' + item.id) ? '120px' : '0px',
            // ----
            'padding-top': ((dataArray['_' + item.id] || {}).data || {}).length
              ? dataArray['_' + item.id].WFSheight - 10 + 'px'
              : '50px',
          }"
        >
          <!-- <FilterSprites
            v-model  = "dataArray['_' + item.id]"
            :boxName = 'boxName'
            :cgid    = "'_' + item.id"
            :dataArray  = 'dataArray'
            :loading="loading"
          />-->

          <div
            class="item"
            v-if="dataArray['_' + item.id]"
            v-for="(itemL, indexL) in (dataArray['_' + item.id] || {}).data"
            :key="itemL.id"
            @click="
              upodatasecens(itemL.id, 'material', { favorites: true });
              materialPushAnalysis({
                type: 'scenes',
                id: item.id,
                name: item.name,
              });
            "
            :style="{
              top: itemL.topWFC - 56 + 'px',
              left: itemL.leftWFC + 'px',
              height: itemL.direction
                ? itemL.direction == 2
                  ? '223px'
                  : '75px'
                : '75px',
              // width: itemL.direction ? (itemL.direction == 2 ? '78px' : '130px') :'130px',
              width: '130px',
            }"
          >
            <img
              :src="$handleAssetsUrl(itemL.thumbnailUrl)"
              :style="{
                height: '100%',
                width: itemL.direction
                  ? itemL.direction == 2
                    ? '100%'
                    : 'auto'
                  : 'auto',
              }"
            />

            <!-- <vipLabel :payType="itemL.payType" :itemData="itemL" :boxName="boxName" /> -->
            <payType-subscript
              :item="itemL"
              style="right: 4px; bottom: 4px"
            ></payType-subscript>
            <el-tooltip
              effect="dark"
              content="收藏"
              placement="top"
              :open-delay="1000"
            >
              <i
                class="collection_sprite_icon"
                :class="[
                  { collection_sprite_icon_active: itemL.favorites },
                  'vipResource_' + itemL.id,
                ]"
                @mouseover="
                  collectionSpriteIconTit($event);
                  stopDocument($event);
                "
                @click="
                  stopDocument($event);
                  collectionSpriteIconFS(itemL, $event);
                "
              ></i>
            </el-tooltip>
          </div>

          <div
            v-loading="loading"
            v-if="loading"
            element-loading-background="rgba(0, 0, 0, 0)"
            element-loading-text="加载中..."
            element-loading-spinner="el-laihua-loading"
            style="width: 100%; height: 20px; margin-top: 37px"
          ></div>
        </div>

        <div class="scenes-more" v-show="slideState && dataMsg == 'scenes'">
          <div class="btn" @click="callSpriteLib()">更多场景</div>
        </div>
      </div>

      <SwitchStyle />
      <CategoryPrompt
        v-show="slideState && dataMsg == 'scenes'"
        v-model="fixTopId"
        :windowMove="windowMove"
        :judgeFixed="judgeFixed"
        :boxName="boxName"
        :dataArray="dataArray"
      />
    </div>

    <div v-show="S_GlobalSearch">
      <Search
        :boxName="boxName"
        :dataMsg="dataMsg"
        v-on:addsprite="upodatasecens"
        :searchDataArray="dataArray"
        :loading="loading"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import rightnavSlide from "../../mixins/rightnavSlide";
import Analysis from "../../mixins/analysis/materialBu";
import Search from "./search/search";
import PayTypeSubscript from "@/components/common/materialPayTypeSubscript";

export default {
  mixins: [rightnavSlide, Analysis],
  data() {
    return {
      boxName: "scenes", // 素材盒子的名字
      dataArray: [], // 数据数组
      scollTop: {
        // 控制滚动条的数据
        default: 0, // 默认添加的高度 - 38(横竖版按钮高度)
        Incremental: 140, // 单个分类的高度
        material: 90, // 单个元素的高度
      },
      dataSet: {
        // 请求数据对象
        pIndex: 0,
        type: 12,
        sOfPage: 24,
        fPage: 24,
        style: null,
      },
      user: true, // 判断是否含有user块
      waterfallComputeData: {
        // 瀑布流的数据
        listNum: 2, // 瀑布流的列数
      },
    };
  },
  props: ["dataMsg"],
  computed: {
    ...mapGetters([
      "TopNav_Size",
      "S_GlobalSearch",
      "S_Scenes",
      "StyleMsg",
      "Window_Size",
      "SelectScenes_Msg",
      "IsVipSprites",
    ]),
  },
  watch: {},
  mounted() {},
  methods: {
    collectScenes() {
      // 收藏元素
      this.$bus.emit("collectPersonal_vue", { data: "scenesSetting" });
    },
  },
  components: {
    Search,
    PayTypeSubscript,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.scenens {
  width: 270px;
  border-radius: 8px;

  .optimized {
    width: 268px;
    height: 38px;
    background: #f0f0f8;
    margin: 0 auto;
    position: relative;
    cursor: pointer;

    .horizontal,
    .Vertical {
      width: 134px;
      height: 38px;
      position: absolute;
      color: #000;
      text-align: center;
      line-height: 38px;
      top: 0;
      transition: all 0.3s;
    }
    .horizontal {
      left: 0;
    }
    .Vertical {
      right: 0;
    }
    .active {
      background: #5778fb;
      color: #fff;
    }
    .hover {
      &:hover {
        background: #95a8f3;
      }
    }
  }

  .collect-scene {
    border-bottom: 2px solid #d4d4e7;
    width: 270px;
    height: 50px;
    padding-left: 18px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .add-icon {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 22px;
      height: 22px;
      margin-right: 14px;
      border-radius: 50%;
      color: #fff;
      background-color: #5778fb;
      cursor: pointer;
    }
    span {
      color: #474261;
    }
  }
  .add-scenes {
    width: 100%;
    height: 75px;
    cursor: pointer;

    > div {
      height: 35px;
      width: 60%;
      margin: 0 auto;
      margin-top: 27px;
      background: rgb(146, 148, 193);
      border-radius: 35px;
      text-indent: 30px;
      text-align: left;
      line-height: 35px;
      color: #fff;
    }
  }
  section {
    width: 270px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #474261;
    right: 0;
    margin-bottom: 5px;
    background: #fff;
    img {
      width: 270px;
      height: 90px;
      background-color: #87307e;
      border-radius: 8px;
      margin-bottom: 9px;
      cursor: pointer;
    }
    .expand-line {
      width: 270px;
      height: 16px;
      background-color: #ccc;
    }
  }

  .data-body {
    padding: 19px 0;
    overflow: hidden;

    .body-list {
      border-top: 2px solid #d6d3d3;
      position: relative;
      min-height: 88px;

      &:before {
        content: "";
        position: absolute;
        top: -6px;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 10px;
        height: 10px;
        background: #fff;
        transform: rotate(135deg);
        border-top: 2px solid #d6d3d3;
        border-right: 2px solid #d6d3d3;
      }

      .item {
        width: 130px;
        height: 75px;
        border-radius: 3px;
        background: #b7b7b7;
        position: absolute;
        background-color: #fafafd;
        border: solid 2px #dbdff0;
        overflow: hidden;
        cursor: pointer;

        &:hover {
          border-color: #5778fb;
        }
        > img {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 0;
          width: 100%;
          height: 100%;
          max-width: 100%;
          max-height: 100%;
        }

        .modify,
        .label {
          position: absolute;
          bottom: 5px;
          right: 5px;
          width: 30px;
          height: 18px;
          background: #d83d60;
          color: #fff;
          border-radius: 5px;
          line-height: 18px;
        }
        .modify {
          width: 35px;
          height: 35px;
          opacity: 0;
          cursor: pointer;
          transition: all 0.3s;
          background-image: url("../../../../static/svg/edit-display-white.svg");
          background-size: 20px 18px;
          background-repeat: no-repeat;
          background-position: center;
        }
        &:hover {
          .modify {
            opacity: 1;
          }
        }
      }
    }
  }
}

@import "./slide.scss";
.scenes-more {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 270px;
  height: 36px;
  text-align: center;
  & > .btn {
    @include bottom-more-btn();
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rightnav/slide/scenes.vue